import { type EngagementDetails, type Action, type AsyncStateObject } from '../../../interfaces'
import { APP_ACTION_STATUS, COMMON_ACTIONS, ENGAGEMENT_ACTIONS } from '../../../utils/constants'

const INITIAL_STATE: AsyncStateObject<EngagementDetails> = {
  data: {
    _id: '',
    name: '',
    description: '',
    status: '',
    statusId: 0,
    startDate: '',
    endDate: '',
    createdBy: '',
    coaches: [],
    coachees: [],
    attachments: [],
    sessions: [],
    roles: []
  },
  isLoading: false,
  status: APP_ACTION_STATUS.INITIAL,
  error: undefined
}

const engagementDetailsReducer = (state = INITIAL_STATE, action: Action<EngagementDetails>) => {
  switch (action.type) {
    case ENGAGEMENT_ACTIONS.GET_ENGAGEMENT_DETAILS + COMMON_ACTIONS.REQUEST:
      return {
        ...state,
        isLoading: true,
        status: APP_ACTION_STATUS.LOADING,
        error: undefined
      }
    case ENGAGEMENT_ACTIONS.GET_ENGAGEMENT_DETAILS + COMMON_ACTIONS.SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: APP_ACTION_STATUS.SUCCESS,
        data: action.data
      }
    case ENGAGEMENT_ACTIONS.GET_ENGAGEMENT_DETAILS + COMMON_ACTIONS.ERROR:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        status: APP_ACTION_STATUS.ERROR,
        error: action.error
      }
    case ENGAGEMENT_ACTIONS.GET_ENGAGEMENT_DETAILS + COMMON_ACTIONS.CLEAR:
      return INITIAL_STATE
    default:
      return state
  }
}

export default engagementDetailsReducer
